import { render } from "./MixFarmsModal.vue?vue&type=template&id=47dc2bed&ts=true"
import script from "./MixFarmsModal.vue?vue&type=script&lang=ts"
export * from "./MixFarmsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__